import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const Navbar = ({ onMenuOpen }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is logged in and get user role
    const token = localStorage.getItem('app_token');
    if (token) {
      try {
        const decodedUser = jwtDecode(token);
        setUser(decodedUser);
        setIsLoggedIn(true);
      } catch (error) {
        console.error("Invalid token:", error);
        setIsLoggedIn(false);
        setUser(null);
      }
    } else {
      setIsLoggedIn(false);
      setUser(null);
    }
  }, []);

  return (
    <nav className="navbar">
      <NavLink to="/" className="nav-item">
        <span className="material-icons">home</span>
        <span className="text-xs">Home</span>
      </NavLink>
      <NavLink to="/resources.html" className="nav-item">
        <span className="material-icons">source</span>
        <span className="text-xs">Resources</span>
      </NavLink>
      {isLoggedIn && (
        <NavLink to="/ai-chat" className="nav-item">
          <span className="material-icons">smart_toy</span>
          <span className="text-xs">AI Chat</span>
        </NavLink>
      )}
      {user && user.role === 'admin' && (
        <NavLink to="/courses" className="nav-item">
          <span className="material-icons">school</span>
          <span className="text-xs">Courses</span>
        </NavLink>
      )}
      <button onClick={onMenuOpen} className="nav-item">
        <span className="material-icons">menu</span>
        <span className="text-xs">Menu</span>
      </button>
    </nav>
  );
};

export default Navbar;
